import type { PurchaseStepValues } from "../../model/form.model";
import type { CartItem } from "../../model/product.cart.model";
import type { PricingStatus } from "../../model/form.model";
import { Customer } from "../../model/customer.model";

import { calculateOrderTotals } from "../calculations/orderTotals";

export type OrderValidation = { ok: true } | { ok: false; reason: string };

export function validateOrder(args: {
  purchase: PurchaseStepValues;
  cart: CartItem[];
  pricingStatus: PricingStatus;
  customerSelected: boolean;
  customerDetails?: Customer;
}): OrderValidation {
  const {
    purchase,
    cart,
    pricingStatus,
    customerSelected,
    customerDetails: customer,
  } = args;

  if (customer && customer.products.length === 0) {
    return {
      ok: false,
      reason:
        "O cliente selecionado não possui produtos cadastrados. Entre em contato com o administrador para cadastrar os produtos antes de realizar o pedido.",
    };
  }

  if (!customerSelected) return { ok: false, reason: "Selecione um cliente." };

  if (!purchase.deliveryAddressId)
    return { ok: false, reason: "Selecione um endereço para prosseguir." };

  if (!purchase.withdrawBasisId)
    return { ok: false, reason: "Selecione uma base de retirada." };

  if (!purchase.deliveryDate)
    return { ok: false, reason: "Selecione uma data de entrega." };

  if (!cart.length)
    return { ok: false, reason: "Adicione ao menos um produto ao carrinho." };

  if (cart.some((p) => !Number(p.quantity) || Number(p.quantity) < 1))
    return {
      ok: false,
      reason: "Todos os produtos devem ter quantidade mínima acima de 1.",
    };

  if (cart.some((p) => !Number(p.subtotal) || Number(p.subtotal) <= 0))
    return {
      ok: false,
      reason: `O produto ${
        cart.find((p) => !Number(p.subtotal) || Number(p.subtotal) <= 0)
          ?.description ?? ""
      } está com valor subtotal zerado.`,
    };

  const totals = calculateOrderTotals(cart);
  if (!Number(totals.totalPrice) || Number(totals.totalPrice) <= 0)
    return { ok: false, reason: "Informe um valor válido para o pedido." };

  if (pricingStatus === "loading")
    return { ok: false, reason: "Aguarde o cálculo de preços." };

  return { ok: true };
}
